export default {"src":"/_next/static/media/integrated-college-icon.472998ce.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};